export default __webpack_public_path__ + "static/media/entrance.bb914fa7.JPG";